export const telephoneNumbers = {
  customerServices: '03330 30 83 96',
  newSales: '03330 30 50 30',
  businessDevelopmentManager: '03330 30 83 89',
  newPolicies: '03330 30 82 74',
  renewals: '03330 30 83 13',
  claims: '03330 30 83 85',
  claimSupport: '03330 30 83 85',
  vetSupport: '03330 30 83 90',
  rehomingSupport: '03330 30 83 89',
  breederSupport: '03330 30 83 75',
  illnessInjurySupport: '03330 30 82 03',
} as const;
